<section class="root">
  @if (viewMode === 'grid') {
  <div class="video-grid">
    <!-- For each video in the list, create a thumbnail -->
    @for (video of displayedVideoSearchResultListPaginated.videos; track $index)
    {
    <div class="video-grid__item">
      <app-video-card [video]="video" [isInternalUser]="isInternalUser"
        (videoDeleted)="onCardVideoDeleted()"></app-video-card>
    </div>
    }
  </div>
  } @else {
  <div class="video-list">
    @for (video of displayedVideoSearchResultListPaginated.videos; track $index) {
    <div class="video-list__item" (click)="onVideoClick(video)">
      <div class="item-icon-col">
        <img src="assets/static/icons/video.svg" width="24" alt="video">
        @if (video && !video.team_check_completed) {
        <img src="assets/static/icons/team-pending.svg" width="24" title="Equipos sin configurar"
          class="pending-icon" />
        }
      </div>
      <div class="item-title-col">
        <span class="video-title">
          @if (video === null) { <span class="skeleton">Cargando...</span> } @else { {{ video.title }} }
        </span>
        @if (video) {
        <span class="video-competition">{{ video.competition }} - {{ video.category }}</span>
        }
      </div>
      <div class="item-date-col">
        @if (video) { <span>{{ video.date | date:'dd/MM/yyyy' }}</span> }
      </div>
      <div class="item-actions-col">
        @if (video && isInternalUser) {
        <button class="delete-btn" (click)="onCardVideoDeleted(); $event.stopPropagation()">
          <img src="assets/static/icons/delete.svg" alt="Eliminar" width="20">
        </button>
        }
      </div>
    </div>
    }
  </div>
  }
  @if (displayedVideoSearchResultListPaginated && displayedVideoSearchResultListPaginated.num_pages >= 1) {
  <div class="paginator-container" style="display: flex; justify-content: center; margin-top: 1rem;">
    <mat-paginator [length]="displayedVideoSearchResultListPaginated.total_items" [pageSize]="pageSize"
      [pageIndex]="displayedVideoSearchResultListPaginated.current_page" (page)="onPageEvent($event)"
      [hidePageSize]="true" showFirstLastButtons aria-label="Seleccionar página">
    </mat-paginator>
  </div>
  }
</section>